(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2178],{

/***/ 2081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/faq",
      function () {
        return __webpack_require__(8880);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);
/* harmony import */ var cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5472);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5549);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7732);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6643);
/* harmony import */ var cds_layout_Main__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3475);
/* harmony import */ var cds_layout_VerticalScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(498);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9809);
/* harmony import */ var hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6016);
/* harmony import */ var hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5397);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3887);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(506);
/* harmony import */ var stream__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9681);
/* harmony import */ var stream__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(stream__WEBPACK_IMPORTED_MODULE_15__);




// components








// hooks


// styles



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 1800px;\n  padding: 24px 16px;\n\n  ",
        " {\n    padding: 48px 72px 64px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n  ",
        ";\n  font-size: 24px;\n  color: ",
        ";\n  ",
        " {\n    font-size: 32px;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  background-color: ",
        ";\n  border: none;\n  color: ",
        ";\n  font-size: 14px;\n\n  & ~ & {\n    margin-left: 8px;\n  }\n\n  ",
        " {\n    height: 48px;\n\n    & ~ & {\n      margin-left: 16px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 8px 16px;\n  justify-content: space-between;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 12px;\n  cursor: pointer;\n\n  & strong {\n    padding-right: 12px;\n  }\n\n  & svg {\n    fill: ",
        ";\n    transform: ",
        ";\n    transform-origin: center;\n  }\n\n  ",
        " {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n\n  & ~ & {\n    margin-top: 8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  padding: 24px 16px;\n  ",
        ";\n  transition: 0.3s ease;\n  overflow: hidden;\n  background-color: transparent !important;\n\n  * {\n    color: ",
        ";\n  }\n  table {\n    width: 100%;\n    border: 1px solid;\n    border-color: ",
        ";\n    margin: 4px 0;\n    text-align: center;\n    font-size: 12px;\n    background-color: transparent !important;\n    caption {\n      display: none;\n    }\n\n    th,\n    td {\n      padding: 10px 4px;\n      border: 1px solid;\n      border-color: ",
        " !important;\n      background-color: transparent !important;\n    }\n\n    tr {\n      background-color: transparent !important;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 20px;\n  counter-reset: detail-counter;\n\n  li {\n    line-height: 2;\n  }\n\n  li::before {\n    display: inline-block;\n    width: 20px;\n    counter-increment: detail-counter;\n    content: '(' counter(detail-counter) ')';\n    margin-left: -24px;\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
/** FAQ 모음집 */ var faq = {
    information: [
        {
            q: 'PC로 수강할 수 있나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "결제한 계정으로 동일하게 로그인해주시면 다른 기기에서도 이용하실 수 있습니다!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "web"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "☞ \xa0홈페이지 우측 상단 [로그인] 버튼 클릭 후 결제한 계정으로 접속!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "app"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "☞ \xa0설치 후 로그인화면에서 결제한 계정으로 시작하기!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "- 결제한 계정이 기억나지 않거나, 로그인이 불가한 상태라면 고객센터로 문의바랍니다."
                    ]
                });
            }
        },
        {
            q: '장학금 제도가 무엇인가요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                        style: {
                            listStyle: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "[미션 수행 시 장학금 지급!]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "미션 완료시 적립금이 지급됩니다🎁",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "지급된 적립금은 클래스유 앱 또는 웹 우측 상단",
                            ' ',
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "마이프로필 > 내정보 > 적립금(원)"
                            }),
                            " 에서 확인할 수 있어요~!",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "지급 금액"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "미션을 모두 진행할 경우 결제금액의 약 10% 획득 가능!",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "(실결제금액\xd710% / 미션수(미션 진행 당시 기준) = 미션 1회 진행시 획득 가능한 포인트)",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "참고해주세요!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "-미션 재인증을 통해 미션을 다시 진행할 수 있으나 적립금은 중복으로 지급되지 않습니다.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "-포인트 지급액은 미션이 추가되거나 제거될 경우 변동이 있을 수 있습니다.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "-평생권은 6개월까지만 장학혜택이 제공됩니다."
                        ]
                    })
                });
            }
        },
        {
            q: '미션인증은 어떻게 하나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "[app]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: " 휴대폰에서 '클래스유'어플을 실행해주세요!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: " 앱 하단 '내 강좌'에서 수강중인 클래스를 클릭합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: " 앱 우측 하단 [미션인증하기] 버튼을 클릭해주세요."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        ' ',
                                        "상단에 미션 내용 확인 후 사진과 내용을 입력하고 '오늘도 나는 해냈다!' 버튼을 클릭하면 끝!"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "[web]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: " 클래스유 홈페이지에 접속하여 로그인해주세요!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "홈페이지 첫 화면 상단 또는 좌측에 수강중인 클래스를 클릭합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "강의 재생화면 우측 하단 [미션인증하기] 버튼을 클릭해주세요."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "상단의 미션 내용 확인 후 사진과 내용을 입력하고 '오늘도 나는 해냈다!' 버튼을 클릭하면 끝!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "미션 진행 시 적립금이 지급됩니다! 클래스를 수강 중이시라면 꼭 미션 인증을 해주세요~!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "미션이 없을 경우 [미션 없음]으로 표기됩니다."
                    ]
                });
            }
        },
        {
            q: '수업은 어떻게 진행되나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "모든 클래스는 녹화본 형태의 온라인 강의로 진행되어 구매하신 수강 기간 내 편한 시간대에",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "자유롭게 청취 가능, 반복 청취 가능, 하루 동안에도 전 강의 시청 가능합니다!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "개강 전 클래스 외 모든 클래스는 결제 후 즉시 이용하실 수 있으며,",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "결제하신 고객님의 경우, '마이프로필 > 내정보 > 결제내역'에서 수강 기간 확인 가능합니다."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "대부분의 클래스는 ot, 1강 무료 제공되고 있으며 강의 화면 하단의 커리큘럼 터치 시 내용 확인 가능합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "해당 부분 참고하여 이용해 주시기 바랍니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: "# 추가 강의 업로드는 강사님 재량에 따라 상이하오니 현재 커리큘럼 기준으로 확인 후 구매 바랍니다. #"
                        })
                    ]
                });
            }
        },
        {
            q: '클래스 준비물은 어떻게 구매하나요? / 배송일자는 어떻게 되나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "클래스 준비물이 있는 클래스의 경우 내강좌 > 강의 목록 하단  [멤버]에 접속 후 상단의 [준비물 구매하기]탭을 누르시면 구매 페이지로 이동합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "(준비물 준비기간 기본 3일 추가 제공되고 있습니다.)",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            style: {
                                color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.red040 */ .DG.red040
                            },
                            children: "<참고해주세요>"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "-준비물을 구매하지 않아도 강의 시청은 가능합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "-준비물은 선택사항으로, 필요시 별도 구매해주셔야하며 타사이트에서 구매하시거나 대체 가능 한 상품으로 이용하셔도 무방한 점 참고바랍니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "**배송일정**"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "- 평일 오전 11시 이전 결제 건에 대하여 준비물이 당일 출고됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "-11시 이후 결제하신 건에 대한 준비물은 익일 출고되며, 금요일 11시이후와 주말에 결제하신 준비물은 평일 영업일에 출고됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "출고 후 지역에 따라 1~2일의 기간이 소요됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: "* 송장번호는 고객센터를 통해 문의주시면 안내해드리겠습니다."
                        })
                    ]
                });
            }
        },
        {
            q: '클래스를 잠시 정지하고 싶어요.',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "모든 클래스는 구매하신 수강기간동안만 이용이 가능하여 정지는 불가능합니다...😢",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "환불 규정을 확인하셔서 환불 진행해주시고, 다시 재수강이 가능하실 때 클래스유를 찾아와 주세요~!"
                    ]
                });
            }
        },
        {
            q: 'TV로 시청하고 싶어요!',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "아쉽게도 현재는 당사에서 직접 제공하고 있는 TV 연결 프로그램이 없습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "번거로우시겠지만 PC와 직접 연결하는 형태로 이용하시거나, TV에서 웹사이트 접속이 가능하시다면 당사 홈페이지로 접속 후 이용해주시면 됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "이 외의 별도의 방법은 직접 모색해주셔야 합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "(일부 기기에서 이용 제한이 있을 수 있으니, 무료로 제공되는 강의 및 OT를 통해 확인 후 이용 부탁드립니다!)"
                        })
                    ]
                });
            }
        },
        {
            q: '알림을 끄고 싶어요!',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "계속되는 알림으로 번거로우신가요?",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "아래와 같은 방법으로 진행하시면 알림을 잠시 꺼두실 수 있습니다~!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "푸쉬알림 끄는 방법"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "앱 우측 상단 '마이프로필 > 내정보 > 알림관리'에서 off 로 설정",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "또는",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "휴대폰 설정 > 어플리케이션 관리 OR 알림 관리 > 클래스유 > 푸쉬 알림 끄기",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "<알람설정 끄는 방법 >"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "내강좌 > 상단 [알람 설정하기] > off 후 저장"
                    ]
                });
            }
        },
        {
            q: '클래스를 개설하고 싶어요!',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "사람들과 공유하고 싶은 재능이나 노하우가 있으신가요?",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "그렇다면 누구나 클래스를 개설할 수 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "앱을 열어 우측 하단 '+' 버튼을 눌러 지금 바로 클래스 개설을 신청해 보세요.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "클래스 개설 비지니스 매니저가 함께 클래스 개설을 기획하고 진행을 도와드립니다."
                    ]
                });
            }
        },
        {
            q: '기업/ 단체 교육 문의하고 싶어요.',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "기업 / 단체의 경우, 원하는 니즈에 따라 커스텀화 된 제안이 가능합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "원하는 목적, 니즈에 따라 2,000개의 클래스에서 담당 매니저가 큐레이션을 진행합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        "담당자분들이 구성원들의 내역을 실시간으로 볼 수 있는 솔루션을 제공합니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "(인원 규모에 따라 실시간 관리가 아닌, 월간 리포트로 대체됩니다.)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "자세한 상담을 희망하시는 경우",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "sk@classu.co.kr"
                        }),
                        "으로 메일 남겨주시면 빠르게 담당자가 연락 드릴 수 있도록 하겠습니다😊"
                    ]
                });
            }
        },
        {
            q: '강사님에게 질문이 있어요!',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "클래스 내용 관련 구체적 사항, 준비물, 수업자료 관련하여 문의하시는 경우라면",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "강사님에게 문의하여 보다 상세하게 답변 받아보실 수 있습니다~!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "1. 강사님 프로필 누르고 팔로우 후 1:1 문의하기",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "OR",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "2. (구매 후) 강좌 화면 하단의 '댓글 남기기' 버튼 누르고 질문하기 버튼을 활성화 하신 후",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "질문 사항 남겨주시면 답변받아보실 수 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "다만, 보다 클래스를 재밌게 즐기고",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "강사와 회원님간의 원활한 소통을 위해",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "'1:1 메세지', '질문' 하기 기능 등으로",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "최대한 피드백 해주실 것 권장드리고 있습니다만",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "필수 의무사항은 아니기 때문에",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "강사님 개인사정에 따라 답변이 지연되거나 없을 수도 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "대부분의 경우에는 가능한 열심히",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "피드백을 해주시고 계시지만",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "강사님마다 피드백률이 상이할 수 있다는 점 참고 부탁 드리며,",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "답변이 지연되어 고객센터로 문의주시면",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "빠른 피드백 진행될 수 있도록 독려할 수 있도록 하겠습니다."
                    ]
                });
            }
        },
        {
            q: '로그아웃 하고 싶어요.',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "클래스유 앱 또는 웹 우측 상단 \xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "마이프로필 > 내정보 > 하단의 [로그아웃]버튼"
                        }),
                        "을 눌러주시면 됩니다!"
                    ]
                });
            }
        }, 
    ],
    payment: [
        {
            q: '환불하고 싶어요.',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            style: {
                                padding: '20px 0 20px',
                                fontSize: '20px'
                            },
                            children: "수강권 환불"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                            style: {
                                width: '100%',
                                border: '1px solid #dadbdc',
                                borderCollapse: 'collapse',
                                fontSize: '14px',
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("caption", {
                                    style: {
                                        marginBottom: '12px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        textAlign: 'left'
                                    },
                                    children: "수강권 환불 규정"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        style: {
                                            padding: '10px',
                                            border: '1px solid #dadbdc',
                                            backgroundColor: '#efefef'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                style: {
                                                    padding: '10px',
                                                    border: '1px solid #dadbdc',
                                                    textAlign: 'center'
                                                },
                                                children: "구분"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                style: {
                                                    padding: '10px',
                                                    border: '1px solid #dadbdc',
                                                    textAlign: 'center'
                                                },
                                                children: "환불액"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                style: {
                                                    padding: '10px',
                                                    border: '1px solid #dadbdc',
                                                    textAlign: 'center'
                                                },
                                                children: "위약금"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강기간 시작일로부터 7일 이내 무료로 오픈된 컨텐츠만을 이용한 경우"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금 전액 "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: "없음"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 1/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 9/10 "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    rowSpan: "8",
                                                    children: "결제금액의 10%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 2/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 8/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 3/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 7/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 4/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 6/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 5/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 5/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 6/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 4/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 7/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 3/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 8/10 경과 전"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: " 결제대금의 2/10 "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            style: {
                                                padding: '10px',
                                                border: '1px solid #dadbdc'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc',
                                                        backgroundColor: '#efefef'
                                                    },
                                                    children: "수강 기간 또는 컨텐츠 이용 9/10 경과 후"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: "환불 불가"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    style: {
                                                        padding: '10px',
                                                        border: '1px solid #dadbdc'
                                                    },
                                                    children: "-"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            style: {
                                padding: '40px 0 20px',
                                fontSize: '20px'
                            },
                            children: "준비물 환불 및 교환"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                                            style: {
                                                width: '20%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                                            style: {
                                                width: '26.666666666666668%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                                            style: {
                                                width: '26.666666666666668%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                                            style: {
                                                width: '26.666666666666668%'
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "구분"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "준비물 상품성 훼손 여부"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "환불액"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "교환 요청 가능 여부"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "배송 완료로부터 7일 이내"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "X"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "결제 금액에서 왕복 택배비를 제한 금액"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "가능"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "배송 완료로부터 7일 이내"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "O"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "청약철회 제한"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "불가"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "배송 완료로부터 7일 초과"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "청약철회 제한"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "불가"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                            style: {
                                marginTop: '15px',
                                listStyle: 'none'
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    style: {
                                        marginBottom: '5px'
                                    },
                                    children: "수강기간이란 회원이 구매한 수강권의 수강 기간을 의미합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "수강기간은 결제일부터 시작하나, 결제일 당시 클래스가 개강되기 전이라면, 수강기간은 클래스가 개강한 날로부터 시작합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "컨텐츠 이용이란, 클래스를 구성하는 컨텐츠 중 이용한 컨텐츠의 비율을 의미합니다. 단, 클래스 영상의 일부 재생 시 이용한 것으로 간주합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "환불 요청일 기준 수강기간과 수강진도 중 높은 값을 적용하여 환불금액을 산정합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "수업 자료를 다운받았을 경우에는 컨텐츠를 이용하신 것으로 간주합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        "사용하신 수강 기간은 클래스 시작일로부터 환불 접수일까지의 기간으로 계산합니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 학습기간 별로 수강기간과 추가 혜택 기간이 존재합니다. 환불은 수강 기간에 대하여만 진행되며, 추가 혜택 기간에는 환불이 불가합니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 1개월권 구매 시 = 수강기간 (31일)",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 3개월권 구매 시 = 수강기간 (93일)",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 6개월권 구매 시 = 수강기간 (186일)",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 평생 수강권은 실 수강기간(6개월)에 추가 혜택기간이 포함된 것으로, 실 수강 기간 종료 후 추가 혜택기간에 클래스의 변화에 관하여는 책임을 지지 않습니다."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "수강기간은 일시정지 하실 수 없으며, 구매하신 수강권(수강 기간)을 이용 중 변경하는 것은 불가능합니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "포인트를 활용하여 결제하신 경우, 환불 시 사용하신 포인트는 반환되지 않습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        "준비물이 배송 준비중에 있을 때 취소 요청을 하신 경우, 배송 업체에 확인 후 환불절차가 진행됩니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 만일 배송이 이미 시작된 경우, 왕복배송비 차감 후 환불이 진행됩니다."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "사은품을 받고 취소를 하신 경우, 사은품은 준비물과 동일하게 보고 결제하신 금액에서 차감 후 환불이 진행됩니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "준비물의 경우, 제조사의 환불 및 A/S 정책을 따릅니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "당일 카드 취소는 즉시 취소확인이 가능하나, 일정 기간이 지난 후 취소한 경우 일부 카드수수료 등이 발생할 수 있으며, 승인 취소가 되기까지 영업일 기준 최대 5일 정도의 기간이 소요됩니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "전액환불 대상이나, 카드 취소가 불가한 경우 계좌이체로 환불이 진행되며 결제 수수료 5%를 제외하고 환불이 진행됩니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey050 */ .DG.grey050
                                        },
                                        children: "* 환급반/ 환불보장 클래스의 경우 당사에서 진행하는 이벤트가 아닌 강사님께서 별도로 진행하는 이벤트이므로, 당사에서 진행하는 환불규정과는 별개의 내용입니다. 해당 클래스 환급 관련 문의는 강사님께 메세지 바랍니다."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            style: {
                                padding: '40px 0 20px',
                                fontSize: '20px'
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "환불 진행 방법"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: "[스마트폰 이용시]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "어플 우측 상단 [마이프로필] > [내정보] > [결제내역] 에서 환불 원하시는 클래스의 [결제 상세 보기] 클릭 후 [환불 신청] 탭 클릭하여 환불 양식 작성하여 신청해주세요.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: "[PC 이용시]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "클래스유",
                                        " 홈페이지 접속하여 우측 상단",
                                        ' ',
                                        "클래스유",
                                        " 아이콘 클릭 [내정보] > [결제내역] 에서 환불 원하시는 클래스의 [결제 상세 보기] 클릭 후 [환불 신청] 탭 클릭하여 환불 양식 작성하여 신청해주세요."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            style: {
                                                color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.red040 */ .DG.red040
                                            },
                                            children: "환불 규정 필시 확인 바랍니다."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                            children: "## 접수일 기준 48시간내 처리 됩니다."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "☞환불 신청 전 고려하셔야 할 사항 안내드립니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "1. 결제일로부터 7일 이전, 무료 강의 외 사용한 강의 없는 경우 적립금, 결제 금액 전액 환불",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "2. 결제일로부터 7일 이전, 무료 강의 외 사용한 강의 있거나 결제일로부터 7일 이후 환불 접수하시는 경우 이용분에 대해 차감 결제금액 10%수수료발생,적립금 환불 X",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                            children: "* 사용일수는 클래스 시작일로부터 환불건 접수해주신 날짜까지를 기준으로 환불이 진행됩니다."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "3. 준비물 환불은 클래스톡내 상담창을 통해 문의해주세요.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "4. 환불기간",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 환불은 평일 09:00~17:00에 처리되며, 계좌이체건 환불은 월/수/금 오후 중으로 처리됩니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- 처리 이후 문자 전송되며, 카드 취소의 경우 2~3일후 취소 문자 발송됩니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "- (문자는 web발신 전용으로 수신이 어렵습니다.)",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            q: '결제(클래스)내역이 보이지 않아요',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "결제하신 계정과 로그인하신 계정이 다른 경우 결제내역이 확인되지 않을 수 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "현재 ",
                        "클래스유",
                        " 로그인 방법은 소셜(네이버,카카오톡, 페이스북)과 핸드폰번호 ID, Biz이메일 발급으로 되어 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "다중으로 가입하실 경우, 하나의 계정으로 연동되지 않고 각각의 독립된 계정으로 생성됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "그렇기에 결제하신 계정으로 로그인하셔야만 내역이 확인 되실거예요.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니 확인해 주시고, 확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인 도와드리겠습니다😊",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                });
            }
        },
        {
            q: '결제내역은 어디에서 볼 수 있나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "클래스유 앱 또는 웹 우측 상단 ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "'마이프로필 > 내정보 > 결제내역'"
                        }),
                        " 에서 확인해보실 수 있습니다!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "결제내역이 확인되지 않으신 경우는, 결제하신 계정과 로그인한 계정이 상이하여 발생할 수 있는 문제로, 로그아웃 후 결제하신 계정으로 접속하여 확인해주세요!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니 확인해 주시고, 확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인 도와드리겠습니다😊"
                    ]
                });
            }
        },
        {
            q: '지급받은 적립금은 어떻게 사용하나요? / 내 적립금은 어디서 확인 가능한가요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "왕성한 활동으로 포인트를 열심히 모아주셨군요. 감사합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "획득하신 포인트는 ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: "'마이프로필 > 내정보 > 적립금(원)'"
                        }),
                        "에서 적립/사용/소멸 내역 및 유효기간 확인 가능하며, 포인트는 '클래스유' 내에서만 사용이 가능합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "원하는 클래스를 골라 결제를 진행하시면 내가 획득한 포인트를 적용하여 할인된 가격에 결제하실 수 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "지금 바로 원하는 클래스를 골라 진행해 보세요.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "단, 준비물은 적립금을 사용하여 구매가 불가합니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "(*적립금은 결제금액의 최대 60%까지 사용이 가능합니다.)",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "(*초대 링크로 접속하신 경우라면 적립금 사용이 제한될 수 있습니다)"
                    ]
                });
            }
        }, 
    ],
    user: [
        {
            q: '비밀번호를 잊어버렸어요.',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "소셜 계정으로 로그인하신 경우, 해당 소셜에서 비밀번호 찾기를 진행해주세요.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "핸드폰 번호로 로그인하신 경우, [로그인] - [비밀번호 찾기]를 클릭하신 후 핸드폰 번호를 입력해주시면 카톡메시지로 재설정 링크를 발송해드립니다",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                });
            }
        },
        {
            q: '탈퇴는 어떻게 하나요?',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "클래스를 이용하시다 불편한 점이 있으셨을까요?",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "불편한 점이 있으셨다면 언제든 고객센터 1:1메세지로 남겨주세요!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "더욱 개선하는 ",
                        "클래스유",
                        "가 되겠습니다!",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "탈퇴는 앱 또는 웹 우측 상단",
                        ' ',
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: "'마이프로필 > 내정보 > 프로필관리' 하단의 [탈퇴하기]탭"
                        }),
                        "을 눌러 진행하실 수 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "탈퇴시 복구가 어려우며, 24시간동안 재가입이 불가하오니 참고 부탁드립니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                });
            }
        },
        {
            q: '수강 신청한 계정이 기억나지 않아요!',
            a: function() {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
                    style: {
                        listStyle: 'none'
                    },
                    children: [
                        "다중으로 가입하실 경우, 하나의 계정으로 연동되지 않고 각각의 독립된 계정으로 생성됩니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "그렇기에 결제하신 계정으로 로그인하셔야만 내역이 확인 되실거예요.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니 확인해 주시고,",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인 도와드리겠습니다😊"
                    ]
                });
            }
        }, 
    ]
};
/** FAQ 페이지 */ var FaqPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), tabIndex = ref[0], setTabIndex = ref[1];
    var MetaTitle = (0,hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().MetaTitle;
    var onClickTab = function(index) {
        return setTabIndex(index);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
        style: {
            listStyle: 'none',
            paddingLeft: 0
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MetaTitle, {
                content: "FAQ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(cds_layout_VerticalScroll__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                            children: "FAQ"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TabWrapper, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabButton, {
                                    selected: tabIndex === 0,
                                    size: "Large",
                                    color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey040 */ .DG.grey040,
                                    onClick: function() {
                                        return onClickTab(0);
                                    },
                                    children: "이용안내"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabButton, {
                                    selected: tabIndex === 1,
                                    size: "Large",
                                    color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey040 */ .DG.grey040,
                                    onClick: function() {
                                        return onClickTab(1);
                                    },
                                    children: "결제"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabButton, {
                                    selected: tabIndex === 2,
                                    size: "Large",
                                    color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey040 */ .DG.grey040,
                                    onClick: function() {
                                        return onClickTab(2);
                                    },
                                    children: "회원정보"
                                })
                            ]
                        }),
                        tabIndex === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InformationFAQ, {}),
                        tabIndex === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaymentFAQ, {}),
                        tabIndex === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserFAQ, {})
                    ]
                })
            })
        ]
    }));
};
/** FAQ 리스트 만들어주는 함수 */ var FaqItem = function(param) {
    var faq1 = param.faq;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setisOpen = ref[1];
    var onClick = function(e) {
        var content = e.target.nextSibling;
        if (isOpen) {
            content.style.display = '';
        } else {
            content.style.display = 'block';
        }
        setisOpen(function(v) {
            return !v;
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OrderedList, {
        style: {
            listStyle: 'none',
            paddingLeft: 0
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownItem, {
                color: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey010 */ .DG.grey010,
                size: "Large",
                onClick: onClick,
                selected: isOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "Q."
                            }),
                            faq1.q
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        name: "ic_arrow_down_r",
                        width: 24,
                        height: 24,
                        fill: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey080 */ .DG.grey080
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownContent, {
                selected: isOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(faq1.a, {})
            })
        ]
    }));
};
/** 이용안내 FAQ */ var InformationFAQ = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: faq.information.map(function(v, idx) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                faq: v
            }, idx);
        })
    }));
};
/** 결제 FAQ */ var PaymentFAQ = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: faq.payment.map(function(v, idx) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                faq: v
            }, idx);
        })
    }));
};
/** 회원정보 FAQ */ var UserFAQ = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: faq.user.map(function(v, idx) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                faq: v
            }, idx);
        })
    }));
};
var Header = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var onCloseWebView = (0,hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().onCloseWebView;
    var onBack = function() {
        if (!onCloseWebView()) {
            router.back();
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        message: "자주 묻는 질문",
        leftSide: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            width: 24,
            height: 54,
            onClick: onBack,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                name: "ic_back_m",
                width: 24,
                height: 24,
                fill: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75,
                stroke: cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75
            })
        })
    }));
};
FaqPage.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        mobileHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {}),
        children: page
    }));
};
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)(cds_layout_Main__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5635f2cb-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-5635f2cb-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.system.BNB */ .DG.system.BNB, cds_typography__WEBPACK_IMPORTED_MODULE_14__/* .h1_medium */ .PN, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.system.grey */ .DG.system.grey);
var TabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5635f2cb-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
var TabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)(cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5635f2cb-3"
})(_templateObject3(), function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey0 */ .DG.grey0 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.BTN.BG */ .DG.BTN.BG;
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey50 */ .DG.grey50;
}, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
var DropdownItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5635f2cb-4"
})(_templateObject4(), function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey0 */ .DG.grey0 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.BTN.BG */ .DG.BTN.BG;
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey50 */ .DG.grey50;
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey50 */ .DG.grey50;
}, function(param) {
    var selected = param.selected;
    return selected ? "rotate(180deg)" : "rotate(0)";
}, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .mediaQuery.large */ .cy.large);
var DropdownContent = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5635f2cb-5"
})(_templateObject5(), cds_typography__WEBPACK_IMPORTED_MODULE_14__/* .body3_regular */ .PD, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.grey25 */ .DG.grey25, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.black */ .DG.black, cds_styles__WEBPACK_IMPORTED_MODULE_13__/* .palette.system.grey */ .DG.system.grey);
var OrderedList = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-5635f2cb-6"
})(_templateObject6());
/* harmony default export */ __webpack_exports__["default"] = (FaqPage);


/***/ }),

/***/ 3496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Both; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/atoms/messages/header/Title.js


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 헤더 타이틀
 * @param {object} props
 * @param {string} props.message
 */ var HeaderTitleMessage = function(param) {
    var message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
        children: message
    }));
};
var Message = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f2958021-0"
})(_templateObject(), styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var Title = (HeaderTitleMessage);

// EXTERNAL MODULE: ./src/components/layout/headers/Base.js
var Base = __webpack_require__(6332);
;// CONCATENATED MODULE: ./src/components/layout/headers/Both.js


// components


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Both_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Both_templateObject() {
    var data = Both_taggedTemplateLiteral([
        "\n  border-bottom: ",
        ";\n\n  ",
        " {\n    height: 84px;\n    border-bottom: ",
        ";\n  }\n"
    ]);
    Both_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = Both_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  max-width: 100%;\n  width: ",
        "px;\n  height: 100%;\n  padding: 0 16px;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Both_taggedTemplateLiteral([
        "\n  flex-basis: 50%;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 좌/우 컨텐츠 존재 헤더
 * @param {object} props
 * @param {string} props.message
 * @param {import('react').ReactNode} props.leftSide
 * @param {import('react').ReactNode} props.rightSide
 * @param {import('react').ReactNode} props.centerSide
 * @param {boolean} props.noBorderBottom
 */ var BothHeader = function(_param) {
    var message = _param.message, leftSide = _param.leftSide, centerSide = _param.centerSide, rightSide = _param.rightSide, noBorderBottom = _param.noBorderBottom, props = _objectWithoutProperties(_param, [
        "message",
        "leftSide",
        "centerSide",
        "rightSide",
        "noBorderBottom"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, _objectSpread({
                noBorderBottom: noBorderBottom
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: leftSide
                        }),
                        centerSide && centerSide,
                        !centerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            message: message
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: rightSide
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Base/* HeaderBlank */.m, {})
        ]
    }));
};
var Header = (0,styled_components_browser_esm/* default */.ZP)(Base/* default */.Z).withConfig({
    componentId: "sc-77bcfba2-0"
})(Both_templateObject(), function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.BNB */.DG.system.BNB);
}, styles/* mediaQuery.large */.cy.large, function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.grey */.DG.system.grey);
});
var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-1"
})(_templateObject1(), styles/* mediaValue.medium */.T8.medium);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-2"
})(_templateObject2(), styles/* palette.grey50 */.DG.grey50);
/* harmony default export */ var Both = (BothHeader);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9681,2725,1223,5644,9809,9774,2888,179], function() { return __webpack_exec__(2081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);